import { apiRequest } from '../../../helpers/functions/request';
import { store } from '../../../store';
import { getTranslate } from 'react-localize-redux';
import { FETCH_SURVEYS, FETCH_SURVEY_FORM, SET_SURVEY, UPDATE_QUESTION, CLEAR_SURVEY } from './types';
import { HANDLE_TABLE_LOADING } from '../../Generic/actions/types';
import { FETCH_TICKET_MEDICAL_RECORDS } from '../../Tickets/actions/types';
import { createAnalyticAction } from '../../Analytic/actions/analyticActions';
import ANALYTIC from '../../../helpers/analytic_logs';
import { fetchTicketbyTokenAction } from '../../Tickets/actions/ticketsActions';
import { parseDateOffset } from '../../../helpers/functions/functions';
import TICKET from '../../../helpers/ticket';
import { setTableCountAction } from '../../Generic/actions/tableActions';
import { handleSplashScreenAction } from '../../Generic/actions/genericActions';
import { push } from 'connected-react-router';
/**
 * Fect Surveys Template Table
 * @param {int} ticket_id Ticket id
 * @returns
 */
export const fetchTableSurveysAction = (table_id, config, pagination, filters) => async (dispatch) => {
	const { localize } = store.getState();
	const translate = getTranslate(localize);

	var fields = [];

	if (config) {
		config.map((field) => {
			if (field.options.renderOnExpand) {
				field.options.display = 'excluded';
			}
			fields.push({
				name: field.label,
				label: translate('table_column_' + field.label),
				options: {
					...field.options,
				},
			});
		});
	}

	await dispatch({
		type: HANDLE_TABLE_LOADING,
		payload: { table_id, loading: true },
	});

	await dispatch({
		type: FETCH_SURVEYS,
		payload: {
			fields,
			data: [],
			total_count: 0,
		},
	});

	let response = await dispatch(getSurveysAction(pagination, fields)).catch((error) =>
		dispatch({
			type: HANDLE_TABLE_LOADING,
			payload: { table_id, loading: false },
		})
	);

	await dispatch({
		type: HANDLE_TABLE_LOADING,
		payload: { table_id, loading: false },
	});
	if (response) {
		return dispatch(setTableCountAction(table_id, response.total_items));
	}
};

export const clearSurveysAction = () => async (dispatch) => {
	await dispatch(handleSplashScreenAction(true));
	await dispatch({
		type: CLEAR_SURVEY,
	});

	return dispatch(handleSplashScreenAction(false));
};

/**
 * Get Ticket surveys list
 * @param {int} ticket_id Ticket id
 * @returns
 */
export const getSurveysAction =
	(table_id = false, fields = []) =>
	async (dispatch) => {
		const state = store.getState();

		const response = await apiRequest({
			method: 'get',
			url: state.config.apihost + `/surveys`,
		});

		dispatch({
			type: FETCH_SURVEYS,
			payload: {
				fields,
				data: response.status == 204 ? [] : response.data.items,
				total_count: response.status == 204 ? 0 : response.data.total_items,
			},
		});

		if (response && table_id) {
			return dispatch(setTableCountAction(table_id, response.data.total_items));
		}
	};

/**
 * Get Survey
 * @param {int} survey_id Survey id
 * @returns
 */
export const getSurveyAction =
	(survey_id, params = {}) =>
	async (dispatch) => {
		const state = store.getState();
		const response = await apiRequest({
			method: 'get',
			url: state.config.apihost + `/surveys/` + survey_id,
			params: { history: true, ...params },
		});

		dispatch({
			type: FETCH_SURVEY_FORM,
			payload: response.data,
		});
	};

/**
 * Get Survey
 * @param {int} survey_id Survey id
 * @returns
 */
export const patchSurveyAction = (survey_id, params) => async (dispatch) => {
	const state = store.getState();
	const response = await apiRequest({
		method: 'patch',
		url: state.config.apihost + `/surveys/` + survey_id,
		params: { history: true, ...params },
	});

	dispatch({
		type: FETCH_SURVEY_FORM,
		payload: response.data,
	});
};

/**
 * Post survey question
 * @param {int} survey_id Survey id
 * @param {int} question_id Question id
 * @param {string} value question text
 * @param {string} form Redux Form survey unique identifier
 * @param {string} field Redux Form field unique identifier
 * @returns
 */
export const postQuestionAction =
	({ survey_id, type, callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		var data = new FormData();
		data.append('type', type);

		const response = await apiRequest({
			method: 'post',
			url: state.config.apihost + `/surveys/` + survey_id + `/questions`,
			data,
			params: { nested: true },
		});

		if (callback) {
			callback();
		}

		dispatch({
			type: FETCH_SURVEY_FORM,
			payload: response.data,
		});
	};

/**
 * Patch survey question text
 * @param {int} survey_id Survey id
 * @param {int} question_id Question id
 * @param {string} value question text
 * @param {string} field Redux Form field unique identifier
 * @returns
 */
export const patchQuestionAction =
	({ survey_id, question_id, value = '', callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		var data = new FormData();

		if (value && typeof value === 'object') {
			Object.keys(value).forEach((key) => {
				data.append(key, value[key]);
			});
		} else {
			data.append('text', value ? value : '');
		}

		const response = await apiRequest({
			method: 'patch',
			url: state.config.apihost + `/surveys/` + survey_id + `/questions/` + question_id,
			data,
			params: { nested: true },
		});

		if (callback) {
			callback();
		}

		dispatch({
			type: FETCH_SURVEY_FORM,
			payload: response.data,
		});
	};

/**
 * Post survey question text
 * @param {int} survey_id Survey id
 * @param {int} question_id Question id
 * @param {string} value question text
 
 * @param {string} field Redux Form field unique identifier
 * @returns
 */
export const deleteQuestionAction =
	({ survey_id, question_id, callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		const response = await apiRequest({
			method: 'delete',
			url: state.config.apihost + `/surveys/` + survey_id + `/questions/` + question_id,
			params: { nested: true },
		});

		if (callback) {
			callback();
		}

		dispatch({
			type: FETCH_SURVEY_FORM,
			payload: response.data,
		});
	};
/**
 * Post survey question
 * @param {int} survey_id Survey id
 * @param {int} question_id Question id
 * @param {string} value question text
 * @param {string} form Redux Form survey unique identifier
 * @param {string} field Redux Form field unique identifier
 * @returns
 */
export const postQuestionOptionAction =
	({ survey_id, question_id, callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		const response = await apiRequest({
			method: 'post',
			url: state.config.apihost + `/surveys/` + survey_id + `/questions/` + question_id + `/options`,
			params: { nested: true },
		});

		if (callback) {
			callback(response.data);
		}

		dispatch({
			type: FETCH_SURVEY_FORM,
			payload: response.data,
		});
	};
/**
 * Patch survey question radio button text
 * @param {int} survey_id Survey id
 * @param {int} question_id Question id
 * @param {string} value question text
 * @param {string} form Redux Form survey unique identifier
 * @param {string} field Redux Form field unique identifier
 * @returns
 */
export const patchQuestionOptionAction =
	({ survey_id, question_id, option_id, value = '', callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		var data = new FormData();

		if (value && typeof value === 'object') {
			Object.keys(value).forEach((key) => {
				data.append(key, value[key]);
			});
		} else {
			data.append('text', value ? value : '');
		}

		const response = await apiRequest({
			method: 'patch',
			url: state.config.apihost + `/surveys/` + survey_id + `/questions/` + question_id + `/options/` + option_id,
			data,
			params: { nested: true },
		});

		if (callback) {
			callback(response.data);
		}

		dispatch({
			type: FETCH_SURVEY_FORM,
			payload: response.data,
		});
	};
/**
 * Post survey question text
 * @param {int} survey_id Survey id
 * @param {int} question_id Question id
 * @param {string} value question text
 * @param {string} form Redux Form survey unique identifier
 * @param {string} field Redux Form field unique identifier
 * @returns
 */
export const deleteOptionAction =
	({ survey_id, question_id, option_id, callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		var data = new FormData();

		const response = await apiRequest({
			method: 'delete',
			url: state.config.apihost + `/surveys/` + survey_id + `/questions/` + question_id + `/options/` + option_id,
			params: { nested: true },
		});

		if (callback) {
			callback();
		}

		dispatch({
			type: FETCH_SURVEY_FORM,
			payload: response.data,
		});
	};
/**
 * Get Ticket surveys list
 * @param {int} ticket_id Ticket id
 * @returns
 */
export const getTicketMedicalRecordsAction = (ticket_id) => async (dispatch) => {
	const state = store.getState();

	const response = await apiRequest({
		method: 'get',
		url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords`,
		params: { history: false, limit: 999, summaries: true },
	});

	dispatch({
		type: FETCH_TICKET_MEDICAL_RECORDS,
		payload: response.data,
	});
};

/**
 * Get User Ticket surveys list
 * @param {int} ticket_id Ticket id
 * @returns
 */
export const getUserTicketMedicalRecordsAction = (ticket_id, user_id) => async (dispatch) => {
	const state = store.getState();

	const response = await apiRequest({
		method: 'get',
		url: state.config.apihost + `/tickets/` + ticket_id + `/users/` + user_id + `/medicalrecords`,
		params: { history: false, limit: 999, summaries: true },
	});

	const ticket_surveys = response.data.items.filter((surv) => surv.ticket_id === ticket_id && surv.type !== 'file');

	const user_surveys = response.data.items.filter((surv) => surv.ticket_id !== ticket_id && surv.type !== 'file');

	const medical_records = response.data.items.filter((surv) => surv.type === 'file');

	response.data.items = [...ticket_surveys, ...user_surveys, ...medical_records];

	dispatch({
		type: FETCH_TICKET_MEDICAL_RECORDS,
		payload: response.data,
	});
};

/**
 * Get Survey current structure
 * @param {int} survey_id Survey id
 * @returns
 */
export const getTicketMedicalRecordAction = (ticket_id, survey_id) => async (dispatch) => {
	const state = store.getState();
	console.log('fetch medical records');
	const response = await apiRequest({
		method: 'get',
		url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords/` + survey_id,
		params: { history: true },
	});

	dispatch({
		type: SET_SURVEY,
		payload: response.data,
	});
};

/**
 * Assign a Suervey to a User
 * @param {int} survey_id Survey id
 * @param {int} user Target user id
 * @param {string} contact_method Contact method
 * @returns
 */
export const assignTicketMedicalRecordAction =
	({ ticket_id, survey_id, user_id, contact_method = false, contact_type = false, callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		const survey_name = state.surveys.items.find((surv) => surv.id == survey_id)?.name;

		var data = new FormData();
		data.append('user_id', user_id);
		data.append('survey_id', survey_id);

		if (contact_method) {
			data.append('contact_method', contact_method);
		}

		if (contact_type) {
			data.append('contact_type', contact_type);
		}

		const response = await apiRequest({
			method: 'post',
			url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords/assign`,
			data,
		});

		await dispatch(
			createAnalyticAction(ANALYTIC.CREATE_JOURNAL, 'tickets', state.tickets.ticket.id, {
				name: survey_name,
			})
		);
		if (callback) {
			callback({ survey: response.data, ticket_id });
		}
		return dispatch(getTicketMedicalRecordsAction(ticket_id));
	};

/**
 * Post survey question answer
 * @param {int} survey_id Survey id
 * @param {int} question_id Question id
 * @param {string} value question answer
 * @param {string} form Redux Form survey unique identifier
 * @param {string} field Redux Form field unique identifier
 * @returns
 */
export const postAnswerAction =
	({ ticket_id, medical_record_id, question_id, form = 'survey', value = '', type = 'string', callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		var data = new FormData();

		if (value && typeof value === 'object') {
			Object.keys(value).forEach((key) => {
				data.append(key, value[key]);
			});
		} else {
			data.append('value', value ? value : '');
		}

		const response = await apiRequest({
			method: 'post',
			url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords/` + medical_record_id + `/questions/` + question_id,
			data,
		});

		if (callback) {
			callback();
		}

		return dispatch(getTicketMedicalRecordAction(ticket_id, medical_record_id));
	};

/**
 * Post survey contact method
 * @param {int} survey_id Survey id
 * @param {int} contact_method Contact method value
 * @param {function} callback callback method on successful api request
 * @returns
 */
export const setMedicalRecordContactMethodAction =
	({ ticket_id, response_id, contact_method, callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		var data = new FormData();

		data.append('contact_method', contact_method);

		const response = await apiRequest({
			method: 'post',
			url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords/` + response_id + `/method`,
			data,
		});

		if (callback) {
			callback();
		}

		return dispatch(getTicketMedicalRecordAction(ticket_id, response_id));
	};

/**
 * Post survey contact type
 * @param {int} survey_id Survey id
 * @param {int} contact_type Contact type value
 * @param {function} callback callback type on successful api request
 * @returns
 */
export const setContactTypeSurveyAction =
	({ ticket_id, response_id, contact_type, callback = false }) =>
	async (dispatch) => {
		const state = store.getState();

		var data = new FormData();

		data.append('contact_type', contact_type);

		const response = await apiRequest({
			method: 'post',
			url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords/` + response_id + `/type`,
			data,
		});

		if (callback) {
			callback();
		}

		return dispatch(getTicketMedicalRecordAction(ticket_id, response_id));
	};

/**
 * Post survey contacted at date
 * @param {int} survey_id Survey id
 * @param {date} contact_type Contacted at date value
 * @param {function} callback callback type on successful api request
 * @returns
 */
export const setContactedAtSurveyAction =
	({ ticket_id, response_id, contacted_at, callback = false, callbackError = false }) =>
	async (dispatch) => {
		const state = store.getState();

		var data = new FormData();

		contacted_at = parseDateOffset(contacted_at).toISOString().split('.')[0] + 'Z';
		contacted_at = contacted_at.replace('T', ' ').replace('Z', '');

		data.append('contacted_at', contacted_at);

		try {
			const response = await apiRequest({
				method: 'post',
				url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords/` + response_id + `/contacted`,
				data,
			});

			if (callback) {
				callback();
			}
		} catch (error) {
			if (callbackError) {
				callbackError();
			}
		}

		return dispatch(getTicketMedicalRecordAction(ticket_id, response_id));
	};

/**
 * Lock/unlock Survey to save history
 * @param {int} ticket_id Ticket id
 * @param {int} survey_id Survey id
 * @param {boolean} save_history value to set
 * @returns
 */
export const setLockSurveyAction =
	({ ticket_id, survey_id, save_history, get_survey = true }) =>
	async (dispatch) => {
		const state = store.getState();

		const response = await apiRequest({
			method: 'post',
			url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords/` + survey_id + `/history`,
			data: { save_history: save_history ? 1 : 0 },
		});

		if (get_survey) {
			return dispatch(getTicketMedicalRecordAction(ticket_id, survey_id));
		}

		return;
	};

/**
 * Sign Survey
 * @param {int} ticket_id Ticket id
 * @param {int} survey_id Survey id
 * @returns
 */
export const setSignSurveyAction =
	({ ticket_id, survey_id }) =>
	async (dispatch) => {
		const state = store.getState();

		await dispatch(
			setLockSurveyAction({
				survey_id: survey_id,
				ticket_id: ticket_id,
				save_history: 1,
				get_survey: false,
			})
		);

		const response = await apiRequest({
			method: 'post',
			url: state.config.apihost + `/tickets/` + ticket_id + `/medicalrecords/` + survey_id + `/sign`,
		});

		return dispatch(getTicketMedicalRecordAction(ticket_id, survey_id));
	};

/**
 * Clear survey reducer
 * @returns
 */
export const clearSurveyAction = () => async (dispatch) => {
	return dispatch({
		type: CLEAR_SURVEY,
	});
};

export const deleteSurveyAction =
	(ticket_id, survey_id, callback = false) =>
	async (dispatch) => {
		const state = store.getState();
		const translate = getTranslate(state.localize);

		await apiRequest({
			method: 'delete',
			url: state.config.apihost + '/tickets/' + ticket_id + '/medicalrecords/' + survey_id,
			submit_form: false,
			success_message: translate('alert_delete_ticket_survey_success'),
		});

		if (callback) {
			callback();
		} else {
			if (state.tickets.ticket.scopes.includes(TICKET.SCOPES.OVERVIEW.SURVEYS_HISTORY)) {
				await dispatch(getUserTicketMedicalRecordsAction(ticket_id, state.tickets.ticket.users_id));
			} else {
				await dispatch(getTicketMedicalRecordsAction(ticket_id));
			}
		}
	};
/**
 * Post survey contact method
 * @param {function} callback callback method on successful api request
 * @returns
 */
export const createSurveyAction = () => async (dispatch) => {
	const state = store.getState();

	const response = await apiRequest({
		method: 'post',
		url: state.config.apihost + `/surveys/create`,
	});

	return dispatch(push('survey/' + response.data.id));
};
/**
 * Post survey contact method
 * @param {function} callback callback method on successful api request
 * @returns
 */
export const duplicateSurveyAction = (survey_id) => async (dispatch) => {
	const state = store.getState();

	const response = await apiRequest({
		method: 'post',
		url: state.config.apihost + `/surveys/` + survey_id + `/duplicate`,
	});

	return dispatch(push('survey/' + response.data.id));
};
/**
 * Post survey contact method
 * @param {function} callback callback method on successful api request
 * @returns
 */
export const deleteSurveysAction = (survey_id) => async (dispatch) => {
	const state = store.getState();
	const translate = getTranslate(state.localize);

	const response = await apiRequest({
		method: 'delete',
		url: state.config.apihost + `/surveys/` + survey_id,
		submit_form: false,
		success_message: translate('alert_delete_ticket_survey_success'),
	});

	return dispatch(push('/surveys'));
};
const surveyActions = {
	getTicketMedicalRecordAction,
	assignTicketMedicalRecordAction,
	postAnswerAction,
	setLockSurveyAction,
	getSurveyAction,
	patchSurveyAction,
	postQuestionAction,
	patchQuestionAction,
	deleteQuestionAction,
	clearSurveyAction,
	setSignSurveyAction,
	setMedicalRecordContactMethodAction,
	setContactTypeSurveyAction,
	setContactedAtSurveyAction,
	deleteSurveyAction,
	patchQuestionOptionAction,
	postQuestionOptionAction,
	deleteOptionAction,
	deleteSurveysAction,
};

export default surveyActions;
